import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoEnviarArte from './ContentSolicitacaoFluxoEnviarArte';

const SolicitacaoFluxoEnviarArte = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSolicitacaoFluxoEnviarArte />
      <Bottom />
    </div>
  );
};

export default SolicitacaoFluxoEnviarArte;
